<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PrmLIX/tc-custom/9781400211296.jpg?1725275551089" alt="This image is the cover for the book When Less Becomes More"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When Less Becomes More
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Women today are more fatigued, burned out, and overwhelmed than ever. You may feel like your life is frantic––that you're running on empty. In <i>When Less Becomes More</i>, you'll learn how to live a life of more in a world that often overwhelms to the point of burnout. </b></p><p>Smartphones constantly ping and alert and demand your attention. And social media can eat up hours of your days with mindless scrolling and tapping while leaving you feeling empty and lonely. Add to that family commitments, work that is accessible around the clock, and overscheduling, and you have a life that can feel out of control.</p><p>In <i>When Less Becomes More</i>, Emily Ley, author of the bestselling <i>Grace, Not Perfection</i> and <i>Growing Boldly</i>, takes you on a journey out of that empty place and shows you how to fill your wells with the nourishment that only true connection can provide. She also presents some radical concepts that push against the tethers of modern life, with the promise that more of the good stuff comes when we say yes to less of what keeps us empty:</p><p>Less Noise, More Calm</p><p>Less Fake, More Real</p><p>Less Rush, More Rhythm</p><p>Less Liking, More Loving</p><p>Less Distraction, More Connection</p><p>Less Chasing, More Cherishing</p><p>Less Stuff, More Treasures</p><p>Getting to more might require some outside-the-box changes, some unraveling of the patterns you have adopted, and some reworking of the day to day. Build a life based on your core values instead of slipping into a life dictated by society or what's "normal." Because you weren't made for normal. You were made for more––for a life of fullness, dreaming, and lasting joy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Ley
      </h2>
      
      <p class="authorDescription body article"><P>Emily Ley is the founder of Simplified&reg;, a brand of planners and organizational tools for busy women, and the creator of <I>The Simplified Podcast</I>. Emily has been featured in <I>Forbes</I>, <I>Glamour</I>, and <I>Good Housekeeping</I>. She has been recognized with numerous awards, including Best New Product at the National Stationery Show, as well as Small Business of the Year, Female Owned Business of the Year, and Entrepreneur of the Year by Studer Community Institute. Emily and her team collaborated with AT-A-GLANCE&reg; to create gift and planning collections carried in Office Depot, Staples, Walmart, and Target. Emily is the author of national bestselling books <I>Grace, Not Perfection: Embracing Simplicity, Celebrating Joy</I>; <I>A Simplified Life: Tactical Tools for Intentional Living</I>; <I>When Less Becomes More: Making Space for Slow, Simple, and Good</I>; and <I>Growing Boldly: Dare to Build a Life You Love</I>. An author, entrepreneur, wife, and mother to three, Emily lives in Pensacola, Florida, with her husband, Bryan, and their son Brady and twins, Tyler and Caroline.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52041e80